<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <router-view />
    </v-slide-y-transition>
    <template v-if="editUserModalContainer">
      <v-dialog v-model="editUserModal" persistent width="390">
        <EditUserProfile @added="onEditUserProfile" @cancelled="onCancelled" />
      </v-dialog>
    </template>
    <template v-if="changePasswordModalContainer">
      <v-dialog v-model="changePasswordModal"  persistent  width="480">
        <ChangePasswordModal @cancelled="onCancelled" />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import EditUserProfile from "./components/user-profile/user-profile";
import ChangePasswordModal from "./components/user-profile/change-password-modal.vue";
import { createModalMixin } from "../../dt-plugins/modal/modal.mixin";
import * as I18nActionTypes from "../../store/app/i18n/types";
export default {
  components: {
    EditUserProfile,
    ChangePasswordModal,
  },
  mounted: function () {
    // this.$store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
    //   "b2b",
    // ]);
  },
  mixins: [
    createModalMixin("editUser"),
    createModalMixin("changePassword"),
  ],
  methods: {
    onEditUserProfile(user) {},
    onCancelled: function () {
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          modal: undefined,
          account_id: undefined,
          external_table: undefined,
        },
      });
    },
  },
};
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
}
</style>
